export default __webpack_public_path__ + "static/media/playerCover.a768188f.png";